<template>
  <div class="wrapper">
    <div class="overlay" @click="showSearch = false" v-if="showSearch"></div>
    <h2 v-if= "false" class="level">{{ "0" + (index + 1) }}</h2>
    <div @click="handleProductClick" class="name">
      <b-avatar
          size="6rem"
          icon="shop-window"
          style="background-color:#fe818c "
          rounded
          :src="faveImgURL"
      />
    </div>
    <tip-tap-output
        v-if="summary && Array.isArray(summary)"
        :content="summary"
        :show-less-char="200"
    />
    <div class="details">
      <span class="read">
        {{ name }}
      </span>
      <span class="ico ico-bookmark" @click="bookMarkBlog">
        <svg
          v-if="isBookMarked"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.333 2H4.66634C3.93301 2 3.33301 2.6 3.33301 3.33333V14L7.99967 12L12.6663 14V3.33333C12.6663 2.6 12.0663 2 11.333 2Z"
            fill="#A1B1BA"
          />
        </svg>
        <svg
          v-else
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.66699 2.66671C4.49018 2.66671 4.32061 2.73695 4.19559 2.86197C4.07056 2.98699 4.00033 3.15656 4.00033 3.33337V12.7046L7.61283 10.1242C7.84463 9.95865 8.15602 9.95865 8.38782 10.1242L12.0003 12.7046V3.33337C12.0003 3.15656 11.9301 2.98699 11.8051 2.86197C11.68 2.73695 11.5105 2.66671 11.3337 2.66671H4.66699ZM3.25278 1.91916C3.62785 1.54409 4.13656 1.33337 4.66699 1.33337H11.3337C11.8641 1.33337 12.3728 1.54409 12.7479 1.91916C13.1229 2.29423 13.3337 2.80294 13.3337 3.33337V14C13.3337 14.2498 13.1941 14.4785 12.972 14.5928C12.75 14.7071 12.4827 14.6877 12.2795 14.5425L8.00033 11.486L3.72115 14.5425C3.51794 14.6877 3.25065 14.7071 3.0286 14.5928C2.80656 14.4785 2.66699 14.2498 2.66699 14V3.33337C2.66699 2.80294 2.87771 2.29423 3.25278 1.91916Z"
            fill="#A1B1BA"
          />
        </svg>
      </span>
      <span class="ico ico-share">
        <svg
          @click="openShare"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9997 1.99996C11.2633 1.99996 10.6663 2.59691 10.6663 3.33329C10.6663 4.06967 11.2633 4.66663 11.9997 4.66663C12.7361 4.66663 13.333 4.06967 13.333 3.33329C13.333 2.59691 12.7361 1.99996 11.9997 1.99996ZM9.33301 3.33329C9.33301 1.86053 10.5269 0.666626 11.9997 0.666626C13.4724 0.666626 14.6663 1.86053 14.6663 3.33329C14.6663 4.80605 13.4724 5.99996 11.9997 5.99996C10.5269 5.99996 9.33301 4.80605 9.33301 3.33329Z"
            fill="#A1B1BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.99967 6.66663C3.26329 6.66663 2.66634 7.26358 2.66634 7.99996C2.66634 8.73634 3.26329 9.33329 3.99967 9.33329C4.73605 9.33329 5.33301 8.73634 5.33301 7.99996C5.33301 7.26358 4.73605 6.66663 3.99967 6.66663ZM1.33301 7.99996C1.33301 6.5272 2.52692 5.33329 3.99967 5.33329C5.47243 5.33329 6.66634 6.5272 6.66634 7.99996C6.66634 9.47272 5.47243 10.6666 3.99967 10.6666C2.52692 10.6666 1.33301 9.47272 1.33301 7.99996Z"
            fill="#A1B1BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9997 11.3333C11.2633 11.3333 10.6663 11.9302 10.6663 12.6666C10.6663 13.403 11.2633 14 11.9997 14C12.7361 14 13.333 13.403 13.333 12.6666C13.333 11.9302 12.7361 11.3333 11.9997 11.3333ZM9.33301 12.6666C9.33301 11.1939 10.5269 9.99996 11.9997 9.99996C13.4724 9.99996 14.6663 11.1939 14.6663 12.6666C14.6663 14.1394 13.4724 15.3333 11.9997 15.3333C10.5269 15.3333 9.33301 14.1394 9.33301 12.6666Z"
            fill="#A1B1BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.42135 8.90698C5.60673 8.58886 6.01489 8.48125 6.33301 8.66663L10.333 11C10.6511 11.1853 10.7587 11.5935 10.5734 11.9116C10.388 12.2297 9.97982 12.3373 9.66171 12.152L5.6617 9.81864C5.34359 9.63326 5.23598 9.2251 5.42135 8.90698Z"
            fill="#A1B1BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.5728 4.08815C10.7584 4.40615 10.651 4.81438 10.333 4.99996L6.33838 7.48488C6.02038 7.67045 5.61215 7.5631 5.42657 7.2451C5.24099 6.9271 5.34834 6.51887 5.66634 6.33329L9.66097 3.84838C9.97897 3.6628 10.3872 3.77015 10.5728 4.08815Z"
            fill="#A1B1BA"
          />
        </svg>
        <div class="share-popup" v-if="showSearch">
          <span @click="shareToFacebook(slug)" class="ico ico-fb">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.1173 0H0.882667C0.395333 0 0 0.395333 0 0.882667V15.1173C0 15.6053 0.395333 16 0.882667 16H8.54533V9.804H6.45933V7.39H8.54533V5.60667C8.54533 3.54067 9.808 2.41667 11.6513 2.41667C12.5347 2.41667 13.294 2.48133 13.5153 2.51067V4.67067H12.2347C11.2347 4.67067 11.04 5.15133 11.04 5.85133V7.392H13.4293L13.1193 9.812H11.04V16H15.1167C15.6053 16 16 15.6053 16 15.1173V0.882667C16 0.395333 15.6053 0 15.1173 0Z"
                fill="#A1B1BA"
              />
            </svg>
          </span>
          <span @click="shareToTwitter(slug)" class="ico ico-tw">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0)">
                <path
                  d="M14.2857 -0.0183105H1.71429C0.767857 -0.0183105 0 0.751546 0 1.70044V14.3046C0 15.2535 0.767857 16.0234 1.71429 16.0234H14.2857C15.2321 16.0234 16 15.2535 16 14.3046V1.70044C16 0.751546 15.2321 -0.0183105 14.2857 -0.0183105ZM12.5393 5.66789C12.5464 5.76815 12.5464 5.87199 12.5464 5.97225C12.5464 9.07674 10.1893 12.6539 5.88214 12.6539C4.55357 12.6539 3.32143 12.2672 2.28571 11.6012C2.475 11.6226 2.65714 11.6298 2.85 11.6298C3.94643 11.6298 4.95357 11.2574 5.75714 10.6272C4.72857 10.6057 3.86429 9.92895 3.56786 8.99796C3.92857 9.05168 4.25357 9.05168 4.625 8.955C3.55357 8.73657 2.75 7.79126 2.75 6.64901V6.62036C3.06071 6.79582 3.425 6.90324 3.80714 6.91756C3.48587 6.7033 3.22249 6.41263 3.04053 6.07149C2.85856 5.73035 2.76365 5.34935 2.76429 4.96248C2.76429 4.52563 2.87857 4.12459 3.08214 3.77726C4.23571 5.20239 5.96786 6.13338 7.91071 6.23364C7.57857 4.64022 8.76786 3.34757 10.1964 3.34757C10.8714 3.34757 11.4786 3.63045 11.9071 4.08879C12.4357 3.98852 12.9429 3.79158 13.3929 3.52303C13.2179 4.0673 12.85 4.52563 12.3643 4.81567C12.8357 4.76554 13.2929 4.63306 13.7143 4.45044C13.3964 4.91951 12.9964 5.33488 12.5393 5.66789Z"
                  fill="#A1B1BA"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span @click="shareToLinkedin(slug)" class="ico ico-li">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.6313 13.6347H11.262V9.922C11.262 9.03667 11.244 7.89733 10.0273 7.89733C8.792 7.89733 8.60333 8.86067 8.60333 9.85667V13.6347H6.234V6H8.51V7.04067H8.54067C8.85867 6.44067 9.632 5.80733 10.7873 5.80733C13.188 5.80733 13.632 7.38733 13.632 9.444V13.6347H13.6313ZM3.558 4.95533C2.79533 4.95533 2.18267 4.338 2.18267 3.57867C2.18267 2.82 2.796 2.20333 3.558 2.20333C4.318 2.20333 4.934 2.82 4.934 3.57867C4.934 4.338 4.31733 4.95533 3.558 4.95533ZM4.746 13.6347H2.37V6H4.746V13.6347ZM14.8167 0H1.18067C0.528 0 0 0.516 0 1.15267V14.8473C0 15.4847 0.528 16 1.18067 16H14.8147C15.4667 16 16 15.4847 16 14.8473V1.15267C16 0.516 15.4667 0 14.8147 0H14.8167Z"
                fill="#A1B1BA"
              />
            </svg>
          </span>
          <span
            v-b-popover.top.hover="popupText"
            @click="copytoClipboard(slug)"
            class="ico ico-copy"
            @mouseleave="changePopupText"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.33301 6.66659C6.96482 6.66659 6.66634 6.96506 6.66634 7.33325V13.3333C6.66634 13.7014 6.96482 13.9999 7.33301 13.9999H13.333C13.7012 13.9999 13.9997 13.7014 13.9997 13.3333V7.33325C13.9997 6.96506 13.7012 6.66659 13.333 6.66659H7.33301ZM5.33301 7.33325C5.33301 6.22868 6.22844 5.33325 7.33301 5.33325H13.333C14.4376 5.33325 15.333 6.22868 15.333 7.33325V13.3333C15.333 14.4378 14.4376 15.3333 13.333 15.3333H7.33301C6.22844 15.3333 5.33301 14.4378 5.33301 13.3333V7.33325Z"
                fill="#A1B1BA"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.66699 2.00008C2.49018 2.00008 2.32061 2.07032 2.19559 2.19534C2.07056 2.32037 2.00033 2.48994 2.00033 2.66675V8.66675C2.00033 8.84356 2.07056 9.01313 2.19559 9.13815C2.32061 9.26318 2.49018 9.33342 2.66699 9.33342H3.33366C3.70185 9.33342 4.00033 9.63189 4.00033 10.0001C4.00033 10.3683 3.70185 10.6667 3.33366 10.6667H2.66699C2.13656 10.6667 1.62785 10.456 1.25278 10.081C0.877706 9.70589 0.666992 9.19718 0.666992 8.66675V2.66675C0.666992 2.13632 0.877706 1.62761 1.25278 1.25253C1.62785 0.877462 2.13656 0.666748 2.66699 0.666748H8.66699C9.19743 0.666748 9.70613 0.877462 10.0812 1.25253C10.4563 1.62761 10.667 2.13631 10.667 2.66675V3.33341C10.667 3.7016 10.3685 4.00008 10.0003 4.00008C9.63214 4.00008 9.33366 3.7016 9.33366 3.33341V2.66675C9.33366 2.48994 9.26342 2.32037 9.1384 2.19534C9.01337 2.07032 8.8438 2.00008 8.66699 2.00008H2.66699Z"
                fill="#A1B1BA"
              />
            </svg>
          </span>
        </div>
      </span>
    </div>
    <div class="profile-badge">
      <img
          v-if="bloggerImgURL"
        @click="handleBloggerProfileClick"
        :src="bloggerImgURL"
        :alt="`${bloggerFullname} picture`"
      />
      <h4 v-if="false" @click="handleBloggerProfileClick" class="name">
        <b-avatar
            style="background-color: #b2ac88"
            variant="success"
            icon="people-fill"
            class="mr-3"
        />
        Written By: {{ bloggerFullname }}
      </h4>
      <button
        class="btn btn-follow"
        :class="isFollowed ? 'followed' : ''"
        @click="handleGetClick"
      >
        <span>Get</span>
      </button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Share from "@/mixins/Share.js";
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  name: "ArticleCard",
  components:{
    TipTapOutput
  },
  props: {
    article: {
      type: Object,
      default: () => {return {}}
    },
    bookMarks: {
      type: Array,
      default: () => { return []}
    },
    followBlogger: {
      type: Array,
      default: () => {return []}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  mixins: [Share],
  computed: {
    isBookMarked() {
      return true;
     /* let isBookMarked = false;
      this.bookMarks.forEach(bookmark => {
        if (bookmark.id == this.article.id) {
          isBookMarked = true;
        }
      });
      return isBookMarked;*/
    },
    isFollowed() {
      return true;
      /*let isFollowed = false;
      this.follwedBloggers.forEach(blogger => {
        console.log(blogger);
        if (blogger.bloggerId == this.article.blogger.bloggerId) {
          isFollowed = true;
        }
      });
      return isFollowed;*/
    }
  },
  methods: {
    handleProductClick(){
      if (this.article && this.article.slug) {
        this.$router.push(`/faves/${this.article.slug}`);
      }
    },
    handleGetClick(){
      if (this.getURL) {
        window.open(this.getURL, "_blank");
      }
    },
    handleArticleClick() {
      this.$router.push(`/blog/a/${this.article.slug}`);
    },
    handleBloggerProfileClick() {
     /* if (this.bloggerProfileName)
        this.$router.push(`/blog/crew/@${this.bloggerProfileName}`);*/
    },
    getDate(date) {
      return moment(date).format("DD MMMM");
    },
    openShare() {
      this.showSearch = !this.showSearch;
    },
    bookMarkBlog() {
      if (this.isBookMarked) {
        let data = {
          type: "remove",
          blog: this.article
        };
        this.$emit("bookMarkBlog", data);
      } else {
        let data = {
          type: "add",
          blog: this.article
        };
        this.$emit("bookMarkBlog", data);
      }
    },
    followBlogger() {
      if (this.isFollowed) {
        let data = {
          type: "unfollow",
          blogger: this.article.blogger
        };
        this.$emit("followBlogger", data);
      } else {
        let data = {
          type: "follow",
          blogger: this.article.blogger
        };
        this.$emit("followBlogger", data);
      }
    }
  },
  data() {
    return {
      name: this.article.form ? this.article.form.name : "",
      slug: this.article.slug ? this.article.slug : "",
      getURL: this.article && this.article.form && this.article.form.url ?
          this.article.form.url: null,
      faveImgURL: this.article.form ? this.article.form.imgURL : null,
      summary: this.article.form ? this.article.form.description : "",
      minsRead: this.article.blog ? this.article.blog.mins : "1",
      imgURL: this.article.blog ? this.article.blog.imgURL : null,
      publishDate: this.article
          ? this.article._created_at
              ? this.getDate(this.article._created_at.toDate())
              : ""
          : "",
      bloggerFullname: this.article.form ? this.article.form.name : "",
      bloggerImgURL: this.article.blogger ? this.article.blogger.imgURL : "",
      bloggerProfileName: this.article.blogger
          ? this.article.blogger.profileName
          : "",
      isSpiritual: this.article
          ? this.article.doc
              ? this.article.doc.spheres
                  ? this.article.doc.spheres.includes("s")
                  : false
              : false
          : false,
      isHealth: this.article
          ? this.article.doc
              ? this.article.doc.spheres
                  ? this.article.doc.spheres.includes("h")
                  : false
              : false
          : false,
      isEducation: this.article
          ? this.article.doc
              ? this.article.doc.spheres
                  ? this.article.doc.spheres.includes("e")
                  : false
              : false
          : false,
      isFinance: this.article
          ? this.article.doc
              ? this.article.doc.spheres
                  ? this.article.doc.spheres.includes("f")
                  : false
              : false
          : false,
      showSearch: false
    };
  }
};
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.wrapper {
  width: 100%;
  padding: 12px;
  background: #ffffff;
  border-radius: 12px;
  user-select: none;
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.08);
  }
  .level {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    color: #a1b1ba;
    margin-bottom: 4px;
    user-select: none;
  }
  .name {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #474d52;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .details {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;

    .categories {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .ico {
        margin-right: 8px;
      }
    }
    .read {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
      margin-right: 8px;
      margin-top: 2px;
    }
    .ico-bookmark {
      margin-right: 8px;
      cursor: pointer;
      &:hover {
        transform: scale(1.07);
      }
    }
    .ico-share {
      cursor: pointer;
      position: relative;
      svg {
        &:hover {
          transform: scale(1.07);
        }
      }
      &:active {
        transform: none;
      }
      .share-popup {
        position: absolute;
        width: 150px;
        height: 45px;
        padding: 10px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        top: 100%;
        left: 80%;
        z-index: 3;
        &:hover {
          transform: none;
        }
      }
    }
  }
  .profile-badge {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    user-select: none;
    grid-column-gap: 8px;
    img {
      cursor: pointer;
      height: 32px;
      width: 32px;
      border-radius: 50%;
      object-fit: cover;
    }
    .name {
      cursor: pointer;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 26px;
      color: #474d52;
      margin: 0;
    }
    .btn-follow {
      z-index: 0;
      border: 1px solid #474d52;
      box-sizing: border-box;
      border-radius: 4px;
      width: 54px;
      height: 20px;
      padding: 0px;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 14px;
      transition: 0.2s ease;
      background-color: #b2ac88;
      &:hover {
        background-color: #fe818c;
        color: #fff;
        &:after,
        &:before {
          content: none;
        }
      }
    }
    .followed {
      width: 65px;
      color: #fff;
      background: #b2ac88;
    }
  }
}
</style>
